var styles = {"input-value":"InputLineAmount-module_input-value__vaaUk","value":"InputLineAmount-module_value__5jCJw"};

export { styles as default };
